import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAuth } from './useAuth';
const PublicRoute = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading)
        return _jsx("div", { children: "Chargement..." });
    // Allow certain public pages even for authenticated users (e.g., reset links)
    const path = window.location.pathname || '';
    const alwaysPublicPrefixes = ['/reset', '/reset-password', '/activate-account', '/verify-2fa', '/change-password', '/forgot-password', '/login'];
    const isAlwaysPublic = alwaysPublicPrefixes.some((p) => path.startsWith(p));
    if (user && !isAlwaysPublic)
        return _jsx(Navigate, { to: "/tasks", replace: true });
    return children;
};
export default PublicRoute;
